import "./Tron.css"
import { Breadcrumbs, Center, Divider, Group, Stack, Text, ThemeIcon, Title } from "@mantine/core"
import Widget1 from "./EventView"
import { Link, useNavigate, useOutletContext } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChartArea } from "@fortawesome/free-solid-svg-icons"




const TronDashboard = () => {

    const navigate = useNavigate()
    const { monitorTabServices } = useOutletContext()

    const selectedSiteId = monitorTabServices.selectedSiteId

    return (
        <div className="flow-vertical fill-parent" style={{gap: 15}} >
            <Stack spacing={4}>
                <Group align="flex-end">
                    <Group mr={20} spacing={4}>
                        <ThemeIcon>
                            <FontAwesomeIcon icon={faChartArea} />
                        </ThemeIcon>
                        <Title order={2}>Tron</Title>
                    </Group>
                    <Breadcrumbs mb={4} separator="/">
                        <Text size="sm" variant="link" component="a" onClick={() => navigate(".."+window.location.search)}>Dashboards</Text>
                        <Text size="sm" color="dimmed">Tron</Text>
                    </Breadcrumbs>
                </Group>
                <Divider />
            </Stack>
            {!selectedSiteId && <Center className="fill-parent"><Text>Please select a site.</Text></Center>}
            {selectedSiteId && <Widget1 selectedSiteId={selectedSiteId} />}
        </div>
    )
}

export default TronDashboard